import { FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST, FETCH_MEETING_PREP_PROMPTERS_CARD_SUCCESS, FETCH_MEETING_PREP_PROMPTERS_CARD_FAILURE  } from "../../actions/meetingPrep/promptersCardActions";


  const initialState = {
    meetingPrepPromptersCardLoading: false,
    meetingPrepPromptersCardData: [],
    meetingPrepPromptersCardError: null,
  };
  
  const meetingPrepPromptersCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MEETING_PREP_PROMPTERS_CARD_REQUEST:
        return { ...state, meetingPrepPromptersCardLoading: true , payload: action.payload};
      case FETCH_MEETING_PREP_PROMPTERS_CARD_SUCCESS:
        return { ...state, meetingPrepPromptersCardLoading: false, meetingPrepPromptersCardData: action.payload };
      case FETCH_MEETING_PREP_PROMPTERS_CARD_FAILURE:
        return { ...state, meetingPrepPromptersCardLoading: false, meetingPrepPromptersCardError: action.payload };       
      default:
        return state;
    }
  };
  
  export default meetingPrepPromptersCardReducer;
  